import { render, staticRenderFns } from "./ManageVaccinePlans.vue?vue&type=template&id=e5cd3fa8&scoped=true"
import script from "./ManageVaccinePlans.vue?vue&type=script&lang=js"
export * from "./ManageVaccinePlans.vue?vue&type=script&lang=js"
import style0 from "./ManageVaccinePlans.vue?vue&type=style&index=0&id=e5cd3fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cd3fa8",
  null
  
)

export default component.exports